import { useUtils } from '@/composables/useUtils'

export default async function ({ route, $auth, redirect }) {
    const { routeOption } = useUtils()

    if (routeOption(route, 'verified', true) && $auth.loggedIn && !$auth.user.email_verified_at) {
        return redirect('/registration/finish')
    }
}
